import React from "react";
import { ContentBlock } from "@/types/case-study";
import { CircleAlert, TriangleAlert, Lightbulb, CircleCheck, CircleX } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface CalloutBlockProps {
  block: ContentBlock;
}

type CalloutVariant = "note" | "info" | "warning" | "tip" | "check" | "danger";

// Map variants to icons
const CALLOUT_ICONS: Record<CalloutVariant, React.ComponentType<{ className?: string }>> = {
  note: CircleAlert,
  info: Lightbulb,
  warning: TriangleAlert,
  tip: CircleAlert,
  check: CircleCheck,
  danger: CircleX,
};

// Map variants to Alert component variants
const CALLOUT_ALERT_VARIANTS: Record<CalloutVariant, "default" | "destructive" | "warning" | "success" | "info" | "tip"> = {
  note: "default",
  info: "info",
  warning: "warning",
  tip: "tip",
  check: "success",
  danger: "destructive",
};

export const CalloutBlock: React.FC<CalloutBlockProps> = ({ block }) => {
  const text = block.content?.text || "";
  const variant = (block.content?.variant || "info") as CalloutVariant;

  const IconComponent = CALLOUT_ICONS[variant];
  const alertVariant = CALLOUT_ALERT_VARIANTS[variant];

  if (!text) {
    return null;
  }

  return (
    <div className="my-6">
      <Alert variant={alertVariant}>
        <IconComponent className="h-4 w-4" />
        <AlertDescription>
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </AlertDescription>
      </Alert>
    </div>
  );
};
